export default __webpack_public_path__ + "static/media/Marathi_cm_2.fdbf1dff.mp3";